module.exports = __webpack_public_path__ + "static/img/56.4b29160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/56.png
// module id = O60w
// module chunks = 0